export default __webpack_public_path__ + "static/biohazard_w.d1089d16c1ccf78f09d03cca4b20fe4a.svg";